import useFreeTrialStatus from '../subscriptions/useFreeTrialStatus';
import useStripeAccountBanner from '../stripe/useStripeAccountBanner';
import useImpersonationBanner from './useImpersonationBanner';
import useBusinessWebRedesignBanner from '../businesses/useBusinessWebRedesignBanner';

function useBanners() {
  const { isBannerShown: isFreeTrialBannerShown } = useFreeTrialStatus();
  const { isBannerShown: isStripeAccountBannerShown } =
    useStripeAccountBanner();
  const { isBannerShown: isImpersonationBannerShown } =
    useImpersonationBanner();
  const { isBannerShown: isRedesignBannerShown } =
    useBusinessWebRedesignBanner();

  return {
    isFreeTrialBannerShown,
    isStripeAccountBannerShown,
    isImpersonationBannerShown,
    isRedesignBannerShown,
    isBannerShown:
      isImpersonationBannerShown ||
      isFreeTrialBannerShown ||
      isStripeAccountBannerShown ||
      isRedesignBannerShown,
  };
}

export default useBanners;
